import Image from "next/image";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import cn from "classnames";

import { BaseButton } from "@/src/component/base/BaseButton";
import { DialogWithExit } from "@/src/component/base/DialogWithExit";
import { StrapiComponentType } from "@/src/type";

import styles from "./FurnishedDetails.module.scss";

interface FurnishedDetailsProps {
  propertyUnitDetails: StrapiComponentType.Section.PropertyUnitDetails;
}

function FurnishedDetails({ propertyUnitDetails }: FurnishedDetailsProps) {
  const [showReadMore, setShowReadMore] = useState(false);

  const handleReadMore = () => {
    setShowReadMore(!showReadMore);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.title}>
          <Image
            src="/image/icon_furnished.svg"
            alt="Beds Icon"
            width={56}
            height={40}
          />
          <Typography
            variant="body1"
            className={styles.titleText}
          >
            {propertyUnitDetails.furnishedByFlowTitle}
          </Typography>
        </div>
        <div className={styles.content}>
          <Typography
            variant="body1"
            className={styles.contentText}
          >
            {propertyUnitDetails.furnishedByFlowDescription}
            <BaseButton
              variant="text"
              className={cn(styles.readMoreButton, styles.contentText)}
              onClick={handleReadMore}
            >
              {propertyUnitDetails.furnishedByFlowReadMore}
            </BaseButton>
          </Typography>
        </div>
      </div>
      <DialogWithExit
        dialogProps={{
          open: showReadMore,
          onClose: handleReadMore,
        }}
        onExit={handleReadMore}
      >
        <div className={styles.readMoreDialog}>
          <div className={styles.title}>
            <div className={styles.titleIcon}>
              <Image
                src="/image/icon_furnished.svg"
                alt="Beds Icon"
                width={48}
                height={40}
              />
            </div>
            <Typography
              variant="body1"
              className={styles.titleText}
            >
              {propertyUnitDetails.furnishedByFlowIncludesTitle}
            </Typography>
            <Typography
              variant="body1"
              className={styles.subtitleText}
            >
              {propertyUnitDetails.furnishedByFlowTitle}
            </Typography>
          </div>
          <ul className={styles.features}>
            {(propertyUnitDetails.furnishedBulletPoints ?? []).map((feature, i) => (
              <li
                key={i}
                className={styles.featureLabel}
              >
                {feature.value}
              </li>
            ))}
          </ul>
        </div>
      </DialogWithExit>
    </>
  );
}

export default FurnishedDetails;
